import state from "./state";
import ApiService from "@/core/services/api.service";

export default {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  fetchStaffGroupMemberNotInList(context, payload) {
    ApiService.setHeader();
    return ApiService.query("school/group/employees/not", {
      params: {
        "page[size]": 30,
        "page[number]": state.pagination.current_page ?? 1,
        "filter[first_name]": state.filters.name,
        id: payload.id,
        employee_type: 2,
      },
    }).then((res) => {
      context.commit("setStaffGroupMemberNotInList", res.data.data);
      context.commit(
        "setStaffGroupMemberNotInListPagination",
        res.data.meta.pagination
      );
      return res;
    });
  },

  /**
   *
   * @param context
   * @param payload
   */
  changeStaffGroupMemberNotInListNameFilters(context, payload) {
    console.log("Name", payload.name);

    let curFilters = state.filters;
    curFilters.name = payload.name;

    context.commit("setStaffGroupMemberNotInListFilters", curFilters);
  },

  selectStaffGroupMemberSaveModification(context, payload) {
    console.log("Info : ", context, payload);

    context.commit("switchStaffGroupMemberSelectionSave", payload.id);
  },
};
